// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"348":"translation3","393":"translation1","413":"translation2","482":"translation4"}[chunkId] + "." + {"348":"9e002533","393":"4e3a87c0","413":"c19b6397","482":"15c452c2"}[chunkId] + ".chunk.js";
};